import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    alert: {
      maxWidth: 500,
      width: 'fit-content',
      margin: '0px auto 8px auto',
      fontSize: 12,

      '& b': {
        fontWeight: 900,
      },
    },
    textAlert: { fontSize: 12 },
    infoIcon: {
      fontSize: 15,
      color: palette.gray,
    },
    buttons: { margin: '16px 0px 0px 8px' },
  });
